import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import StaffPaperPendencyDay from './Elements/StaffPaperPendencyDay';
import StaffPaperEditDay from './Elements/StaffPaperEditDay';
import StaffPaperApprovals from './Elements/StaffPaperApprovals';
import getLocale from '../../i18n/getLocale';

class StaffPapersEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      key: 100,
      staff_paper_id: this.props.match.params.id,
      status: 0,
      staff_paper: {},
      staff: {},
      staff_paper_pendency_days: [],
      staff_paper_days: [],
      schedule_initials_select: [],
      aircraft_models_select: [],
      staff_paper_approvals: [],
      staff_paper_warnings: [],
      staff_alerts: [],
      global_alerts: [],
      modal_alerts: false,
      updated: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.exportPdf = this.exportPdf.bind(this);
    this.loadData = this.loadData.bind(this);
    this.changeParentState = this.changeParentState.bind(this);
    this.warnings = this.warnings.bind(this);
    this.autoUpdate = this.autoUpdate.bind(this);
    this.updateData = this.updateData.bind(this);
    this.changeUpdate = this.changeUpdate.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  changeParentState(data) {
    this.setState(data);
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/papeleta/info/edicao/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/papeletas');
        if (responseJson.status === 'success') {
          self.setState({
            staff_paper: responseJson.data.main,
            status: responseJson.data.main.status,
            staff: responseJson.data.main.staff,
            staff_paper_days: responseJson.data.staff_paper_days,
            staff_paper_pendency_days: responseJson.data.main.staff_paper_pendency_days,
            staff_paper_approvals: responseJson.data.staff_paper_approvals,
            schedule_initials_select: responseJson.data.schedule_initials_select,
            aircraft_models_select: responseJson.data.aircraft_models_select,
            staff_paper_warnings: responseJson.data.staff_paper_warnings,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

  exportPdf(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');

    var datasave = {
      id: self.props.match.params.id,
    };

    self.handleAlert(this.locale.Papeletas.EditarPapeleta.aguardeEnquantoOArquivoEGerado, 'warning', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeleta/tripulante/pdf', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          self.setState({
            url_export: url,
          });
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }


  warnings() {
    var self = this;
    var url = "/papeletas/alertas/";
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staff_alerts: responseJson.data.staff, global_alerts: responseJson.data.global, modal_alerts: true});
          self.handleAlert('', '', 'closed');
        }
      });
    });
  }

  autoUpdate() {
    var self = this;
    if(window.confirm(this.locale.Papeletas.EditarPapeleta.atualizarAsInformacoes)) {
    
      var url = "/papeletas/atualizar/";
      var header = this.refs.request_api.header('application/json');
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              staff_paper: responseJson.data.staff_paper,
              status: responseJson.data.staff_paper.status,
              staff: responseJson.data.staff_paper.staff,
              staff_paper_days: responseJson.data.staff_paper_days,
              staff_paper_pendency_days: responseJson.data.staff_paper.staff_paper_pendency_days,
              updated: true,
            });
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        });
      });
    }
  }

  updateData(responseJson) {
    this.setState({
      staff_paper: responseJson.data,
      status: responseJson.data.status,
      staff: responseJson.data.staff,
      staff_paper_days: responseJson.data.staff_paper_days,
      staff_paper_pendency_days: responseJson.data.staff_paper_pendency_days,
      updated: true,
    });

    this.handleAlert(responseJson.message, responseJson.status, 'open');
  }

  changeUpdate(responseJson) {
    this.setState({
      updated: false,
    });
  }
 

  render() {
    var self = this;
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Papeletas.EditarPapeleta.titulo} - {self.state.staff.name} - {self.state.staff_paper.month}</h3>
      <div className="grid-buttons pull-right">
        <button onClick={() => self.autoUpdate()} className="btn btn-success"><i className="fa fa-fw fa-refresh"></i>  {this.locale.Papeletas.EditarPapeleta.botaoAtualizar}</button>
        <button onClick={() => {this.exportPdf()}} className="btn btn-info"><i className="fa fa-fw fa-file-pdf-o"></i> {this.locale.general.exportarPDF}</button>
        <button onClick={() => self.warnings()} className="btn btn-warning"><i className="fa fa-fw fa-warning"></i>  {this.locale.Papeletas.EditarPapeleta.botaoAlertas}</button>
        <Link to="/papeletas/abertas" className="btn btn-default"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      </div>
      <div className="clearfix"></div>
      <hr/>
      {(this.state.staff_paper.completed === 1) ?
        <StaffPaperApprovals handleAlert={this.handleAlert} staff_paper_id={this.props.match.params.id} staff_paper_approvals={this.state.staff_paper_approvals} staff_paper={this.state.staff_paper} changeParentState={self.changeParentState} /> 
        : ''
      } 
      {(self.state.staff_paper_pendency_days.length > 0) ?
        <div>
          <h3 className="page-title">{this.locale.Papeletas.EditarPapeleta.tituloPendencias}</h3>
          <hr/>
          <div className="table-responsive">
            <table className="table table-bordered table-papers-main table-hover table-striped">
              <thead>
                <tr>
                  <th rowSpan={2} style={{width:"100px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Data}</th>
                  <th colSpan={2} style={{width:"310px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Localidades}</th>
                  <th rowSpan={2} style={{width:"155px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Situacao}</th>
                  <th colSpan={6} style={{width:"1200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Horarios}</th>
                  <th colSpan={3} style={{width:"360px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Totais}</th>
                  <th rowSpan={2} style={{width:"50px"}} className="text-center"></th>
                  <th rowSpan={2} style={{width:"50px"}} className="text-center"></th>
                  <th rowSpan={2} style={{width:"50px"}} className="text-center"></th>
                </tr>
                <tr>
                  <th style={{width:"155px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Apresentacao}</th>
                  <th style={{width:"155px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Liberacao}</th>
                  <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Apresentacao}</th>
                  <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.InicioDaRefeicao}</th>
                  <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.TerminoDaRefeicao}</th>
                  <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.InicioDaSegundaRefeicao}</th>
                  <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.TerminoDaSegundaRefeicao}</th>
                  <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Liberacao}</th>
                  <th style={{width:"120px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.HorasDeJornada}</th>
                  <th style={{width:"120px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.VooNoturno}</th>
                  <th style={{width:"120px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.VooTotal}</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(self.state.staff_paper_pendency_days).map(function(k) {
                  var day = self.state.staff_paper_pendency_days[k];
                  return (
                    <StaffPaperPendencyDay RequestApi={self.refs.request_api} handleAlert={self.handleAlert} changeUpdate={self.changeUpdate} updated={self.state.updated} updateData={self.updateData} staff_paper_id={self.props.match.params.id} day={day} schedule_initials_select={self.state.schedule_initials_select} aircraft_models_select={self.state.aircraft_models_select} status={self.state.status} />
                  );
                })}
              </tbody>
            </table>
          </div>
          <hr/>
        </div>
        : ''
      }

      {/* <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
          {Object.keys(self.state.staff_paper_days).map(function(k) {
            var day = self.state.staff_paper_days[k];
            return (
              <Tab eventKey={k} title={day.date_str}>
                <StaffPaperEditDay handleAlert={self.handleAlert} staff_paper_id={self.props.match.params.id} day={day} schedule_initials_select={self.state.schedule_initials_select} aircraft_models_select={self.state.aircraft_models_select} />
              </Tab>
            );
          })}
        <Tab eventKey={100} title="Aprovações">
          <StaffPaperApprovals handleAlert={this.handleAlert} staff_paper_id={this.props.match.params.id} staff_paper_approvals={this.state.staff_paper_approvals} staff_paper={this.state.staff_paper} />
        </Tab>
      </Tabs> */}
      <h3 className="page-title">{this.locale.Papeletas.EditarPapeleta.tituloPapeleta}</h3>
      <hr/>
      <div className="table-responsive">
        <table className="table table-bordered table-papers-main table-hover table-striped">
          <thead>
            <tr>
              <th rowSpan={2} style={{width:"100px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Data}</th>
              <th colSpan={2} style={{width:"310px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Localidades}</th>
              <th rowSpan={2} style={{width:"155px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Situacao}</th>
              <th colSpan={12} style={{width:"2400px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Horarios}</th>
              <th colSpan={3} style={{width:"360px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Totais}</th>
              <th rowSpan={2} style={{width:"50px"}} className="text-center"></th>
              <th rowSpan={2} style={{width:"50px"}} className="text-center"></th>
              <th rowSpan={2} style={{width:"50px"}} className="text-center"></th>
              <th rowSpan={2} style={{width:"50px"}} className="text-center"></th>
            </tr>
            <tr>
              <th style={{width:"155px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Apresentacao}</th>
              <th style={{width:"155px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Liberacao}</th>
              <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.ApresentacaoData}</th>
              <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.ApresentacaoHora}</th>
              <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.InicioDaRefeicaoData}</th>
              <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.InicioDaRefeicaoHora}</th>
              <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.TerminoDaRefeicaoData}</th>
              <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.TerminoDaRefeicaoHora}</th>
              <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.InicioDaSegundaRefeicaoData}</th>
              <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.InicioDaSegundaRefeicaoHora}</th>
              <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.InicioDaSegundaRefeicaoData}</th>
              <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.TerminoDaSegundaRefeicaoHora}</th>
              <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.LiberacaoData}</th>
              <th style={{width:"200px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Liberacaohora}</th>
              <th style={{width:"120px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.HorasDeJornada}</th>
              <th style={{width:"120px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.VooNoturno}</th>
              <th style={{width:"120px"}} className="text-center vcenter">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.VooTotal}</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(self.state.staff_paper_days).map(function(k) {
              var day = self.state.staff_paper_days[k];
              return (
                <StaffPaperEditDay handleAlert={self.handleAlert} changeUpdate={self.changeUpdate} updated={self.state.updated} updateData={self.updateData} staff_paper_id={self.props.match.params.id} day={day} schedule_initials_select={self.state.schedule_initials_select} aircraft_models_select={self.state.aircraft_models_select} status={self.state.status} />
              );
            })}
          </tbody>
        </table>
      </div>
      <hr/>
      <h3 className="page-title">{this.locale.Papeletas.EditarPapeleta.tituloAlertasDoRelatorio}</h3>
      <hr/>
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-striped">
          <thead>
            <tr>
              <th>{this.locale.Papeletas.EditarPapeleta.tabelaAlertasDoRelatorio.Mensagem}</th>
            </tr>
          </thead>
          <tbody>
          {Object.keys(self.state.staff_paper_warnings).map(function(k) {
            var spw = self.state.staff_paper_warnings[k];
            return (
              <tr>
                <td className={"box-alert box-alert-" + spw.color}><div dangerouslySetInnerHTML={{__html: spw.message}}></div></td>
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <Modal show={this.state.modal_alerts} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left"><strong>{this.locale.Papeletas.EditarPapeleta.tituloAlertas}</strong></h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_alerts: false})}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      {
        Object.keys(self.state.staff_alerts).map(function(nickname) {
          var alerts = self.state.staff_alerts[nickname];
          return(
            <div>
              {Object.keys(alerts).map(function(k) {

var alert = alerts[k];
                if (alert !== null && alert.error === 1) {
                  return(
                    <div className={"box-alert box-alert-" + alert.color}>
                      <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                    </div>
                  );
                }
              })}
            </div>
          );
        })
      }
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_alerts: false})}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default StaffPapersEdit;



// WEBPACK FOOTER //
// ./src/Components/StaffPapers/StaffPapersEdit.js